export const GENERAL_COMMUNICATON_TOPICS = {
    DASH_INIT: 'init',
    UPDATE_DASHBOARD_PATH: 'update-dashboard-path',
    ACCESS_TOKEN: 'access-token',
    REFRESH_TOKEN: 'refresh-token',
    CONTEXT: 'context',
    DASHBOARD_HISTORY_LISTEN: 'dashboard-history-listen',
    COMMUNICATE_PENDO_USER: 'communicate-pendo-user',
    GET_PENDO_USER: 'get-pendo-user-data',
    GET_ACCESS_CONTROLS: 'get-access-controls',
    COMMUNICATE_ACCESS_CONTROLS: 'communicate-access-controls',
    NOTIFICATIONS: 'mf-notification',
    OPEN_LINK: 'open-link',
};
export const ANS_COMMUNICATON_TOPICS = {
    INIT_COMPLETED: 'ans-init-completed',
    GET_USER_DATA: 'ans-get-user-data',
    COMMUNICATE_USER_DATA: 'ans-communicate-user-data',
    ADD_ALERT_RECIPIENTS: 'ans-add-alert-recipients',
    SAVE_ALERT_RECIPIENTS: 'ans-save-alert-recipients',
    RENDER_ERROR: 'ans-render-error',
};
export const QLT_COMMUNICATON_TOPICS = {
    QLT_INIT: 'qlt-init',
    QLT_VIEW_MODE: 'qlt-view-mode',
    INIT_COMPLETED: 'qlt-init-completed',
    RENDER_ERROR: 'qlt-render-error',
};
export const PF_COMMUNICATION_TOPICS = {
    MF_READY: 'pf-mf-ready',
    INIT: 'pf-init',
    INIT_COMPLETED: 'pf-init-completed',
    VALIDATE_POSTBACK: 'pf-validate-postback',
    VALIDATE_POSTBACK_SUCCESS: 'pf-validate-postback-success',
    VALIDATE_POSTBACK_ERROR: 'pf-validate-postback-error',
    SAVE_POSTBACK: 'pf-save-postback',
    SAVE_POSTBACK_SUCCESS: 'pf-save-postback-success',
    SAVE_POSTBACK_ERROR: 'pf-save-postback-error',
    HAS_UNSAVED_CHANGES: 'pf-has-unsaved-changes',
    WAIT_FOR_CONFIRMATION: 'pf-wait-for-confirmation',
    WAIT_FOR_CONFIRMATION_ACCEPT: 'pf-wait-for-confirmation-accept',
    WAIT_FOR_CONFIRMATION_DENY: 'pf-wait-for-confirmation-deny',
    RENDER_ERROR: 'pf-render-error',
};
export const USAGE_COMMUNICATION_TOPICS = {
    MF_READY: 'usage-mf-ready',
    INIT_COMPLETED: 'usage-init-completed',
    RENDER_ERROR: 'usage-render-error',
};
export const ADS_STATS_COMMUNICATION_TOPICS = {
    MF_READY: 'ads-stats-ready',
    INIT_COMPLETED: 'ads-stats-init-completed',
    GET_BY_RANGE_DATE: 'ads-stats-get-by-date-range',
    DOWNLOAD_REPORT: 'ads-stats-download_report',
    RENDER_ERROR: 'ads-stats-render-error',
};
export const QR_CODE_CUSTOMIZATIONS_COMMUNICATION_TOPICS = {
    INIT_COMPLETED: 'qr-code-customizations-init-completed',
    RENDER_ERROR: 'qr-code-customizations-render-error',
};
export const JOURNEY_CREATIVES_OPTIMIZATION_COMMUNICATION_TOPICS = {
    INIT_COMPLETED: 'journeys-creatives-optimization-init-completed',
    RENDER_ERROR: 'journey-creatives-optimization-render-error',
};
//# sourceMappingURL=communicationTopics.js.map